import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { menuCategoryDtoSchema, type MenuCategoryDto } from '@tg-hookah/shared/dto';
import { api } from '@/lib/api';

const treeSchema = z.array(menuCategoryDtoSchema);

async function fetchMenu(): Promise<MenuCategoryDto[]> {
  const res = await api.get('/menu');
  return treeSchema.parse(res.data);
}

export function useMenu() {
  return useQuery({
    queryKey: ['menu'],
    queryFn: fetchMenu,
    staleTime: 30_000,
  });
}
